 <app-components-managecustomer-customerusers
  [customer]="customer"
  [user]="user"
  [partner]="partner"
  [footerTemplate]="priorityViewFooter"
  (refreshCustomer)="refreshCustomer()">
</app-components-managecustomer-customerusers>
<ng-template #priorityViewFooter>
  <ng-container *ngIf="priorityViewApi">
    <div class="row pt-3 px-2">
      <div class="col-lg-12">
        <div class="card card-body bg-light d-block text-end">
          <div *ngIf="noContactInfo" class="text-danger">All users are marked as "Do Not Contact" - Please add a user
            for the person we should contact for this campaign.</div>
          <span class="pe-3">Please ensure the details above are correct for the point of contact for
            setup and management of the account.</span>
          <button [disabled]="noContactInfo" (click)="close()" type="button"
            class="btn btn-primary">Done</button>
        </div>
      </div>
    </div>
  </ng-container>
</ng-template>